/* 
Pantalla de confirmacion una vez registrado
 */

import React from "react";

//COMPONENTS
import AlertDialog from "../../components/AlertDialog";

//REDUX
// import { useDispatch } from "react-redux";
// import { resendConfirmationMailAction } from "../../redux/actions/userActions";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import DialogContentText from "@material-ui/core/DialogContentText";
import Typography from "@material-ui/core/Typography";
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "10px",
    display: "flex"
  },
  border: {
    boxShadow: "0px 0px 3px 1px #9abf3a",
    paddingTop: "40px",
    paddingBottom: "40px",
    marginTop: "60px",
    marginBottom: "50px"
  },
  labelBig: {
    fontSize: "1.25rem",
    align: "justify"
  }
}));
//#endregion

function Registered({ history, match }) {
  const classes = useStyles();

  //#region Values
  const { mail } = match.params;
  const [showDialog, setShowdialog] = React.useState(false);
  // eslint-disable-next-line
  const [message, setMessage] = React.useState("");
  //#endregion

  //#region DISPATCH & SELECTOR
  // const dispatch = useDispatch();
  // const resendConfirmationMail = mail => dispatch(resendConfirmationMailAction(mail));
  //#endregion

  //#region OnClick
  /*const onClickResendConfirmationMail = () => {
    resendConfirmationMail(mail)
      .then(v => {
        setShowdialog(true);
        setMessage("Hemos reenviado el email de confirmación.");
      })
      .catch(e => {
        setShowdialog(true);
        setMessage("Ha habido un problema, vuelve a intentarlo.");
      });
  };*/

  const onClickGotoClub = () => {
      history.push("/" + mail);
  };  
  //#endregion

  return (
    <div className={classes.root}>
      <AlertDialog show={showDialog} setShow={setShowdialog}>
        <DialogContentText id="alert-dialog-slide-description">
          {message}
        </DialogContentText>
      </AlertDialog>
      <Grid container spacing={2} justify="center" alignItems="center">
        <Fade in={true} timeout={1000}>
          <Grid item xs={11} md={6} lg={4} xl={3}>
            <Box textAlign="center">
              <img
                alt="Logo"
                src={`${process.env.PUBLIC_URL}/assets/img/logo_V2.png`}
                title="Logo"
                height="100px"
                className="mt-5"
              />
            </Box>
            <Grid item xs={12} className={`${classes.border}`}>
              <Box textAlign="center">
                <Typography color="secondary" variant="h5" data-lang="register_success_title">
                  Bienvenido a Ilusiona Club
                </Typography>
              </Box>
              {/* <Box textAlign="center" >
                <label className="mb-0 mt-4" style={{ width: "85%" }}>
                  Esta a punto de entrar al club, sólo
                  <span className={classes.labelBig}>
                    {" "}
                    necesitas confirmar tu email en {mail}.
                  </span>{" "}
                  Por favor, revisa tu bandeja de entrada para confirmarlo.{" "}
                  <a
                    href="#0"
                    onClick={onClickResendConfirmationMail}
                    style={{ color: "#9abf3a", display: "block", marginTop: "15px" }}
                  >
                    VOLVER A ENVIAR
                  </a>
                </label>
              </Box> */}
              <Box textAlign="center">
                <label align="justify" className="mb-0 mt-4" data-lang-html="register_success_message">
                  Enhorabuena ya puedes iniciar sesión en Ilusiona Club
                </label>
                <label align="justify" className="mb-0 mt-4" data-lang-html="register_card_message">
                  en breve recibirás en el buzón de correo tu tarjeta
                </label>
              </Box>
              <div style={{ textAlign: "center" }}>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ width: "80%" }}
                  className={"mt-4"}
                  onClick={onClickGotoClub}
                  data-lang="register_go_to_club"
                >
                  Entrar al Club
                </Button>
              </div>            </Grid>
          </Grid>
        </Fade>
      </Grid>
    </div>
  );
}

export default Registered;
